import React,{useState} from 'react';
// comps
import FriendPart from '../comps/friendPart'
import {Helmet} from "react-helmet";

const Visted = props => {
  const[isType,setType] = useState('h');
  return(
  <section className="FollowPage">
  <Helmet>
    <title>Following</title>
       <meta name="theme-color" content="#0f0f0f" />
  <meta name="description" content='check how many followers do you have now '/>
<meta name='keywords' content='frinds,around,follow page'/>
 <link rel="canonical" href="https://pinweelo.com/followers" />
    </Helmet>

<FriendPart page={true} />

  </section>
  )
}
export default Visted;
